import { render, staticRenderFns } from "./ProviderList.vue?vue&type=template&id=b0c95944&scoped=true&"
import script from "./ProviderList.vue?vue&type=script&lang=js&"
export * from "./ProviderList.vue?vue&type=script&lang=js&"
import style0 from "./ProviderList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProviderList.vue?vue&type=style&index=1&id=b0c95944&lang=scss&scoped=true&"
import style2 from "./ProviderList.vue?vue&type=style&index=2&id=b0c95944&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c95944",
  null
  
)

export default component.exports